export default "__VITE_ASSET__7157be4d__"